import { ColumnsType } from 'antd/lib/table';
import { ESearchParams, ESort } from 'common/const/enums.const';
import { convertToMinutes } from 'common/helpers/time.helper';
import { IOperationModel } from 'entities/Operations/Operations.models';

export const getOperationsSearchParams = (searchParams: URLSearchParams) => {
  const search = searchParams.get(ESearchParams.Search);
  const dateFrom = searchParams.get(ESearchParams.DateFrom);
  const dateTo = searchParams.get(ESearchParams.DateTo);
  const orderField = searchParams.get(ESearchParams.OrderField);
  const orderDirection = searchParams.get(ESearchParams.OrderDirection);

  return {
    search: search ? search : undefined,
    dateFrom: dateFrom ? dateFrom : undefined,
    dateTo: dateTo ? dateTo : undefined,
    orderField: orderField ? orderField : ESort.StaffName,
    orderDirection: orderDirection ? orderDirection : 'DESC',
  };
};

export const renderOperationsRecords = () => {
  return [
    {
      title: 'Staff member',
      dataIndex: 'staffName',
      key: 'staffName',
      sorter: true,
    },
    {
      title: 'Diary Items Handled',
      dataIndex: 'eventCount',
      key: 'eventCount',
      sorter: true,
    },
    {
      title: 'Minutes spent on Diary Items Review',
      dataIndex: 'timeSpent',
      key: 'timeSpent',
      sorter: true,
      render: (text) => convertToMinutes(text),
    },
    {
      title: 'CCM Enrollment Events Handled',
      dataIndex: 'ccmEnrollmentsCount',
      key: 'ccmEnrollmentsCount',
      sorter: true,
    },
    {
      title: 'CCM Patients Served',
      dataIndex: 'ccmPatientsCount',
      key: 'ccmPatientsCount',
      sorter: true,
    },
    {
      title: 'Minutes spent on CCM Patients',
      dataIndex: 'ccmTimeSpent',
      key: 'ccmTimeSpent',
      sorter: true,
      render: (text) => convertToMinutes(text),
    },
    {
      title: 'Total Minutes Spent',
      dataIndex: 'totalTimeSpent',
      key: 'totalTimeSpent',
      sorter: true,
      render: (text) => convertToMinutes(text),
    },
  ] as ColumnsType<IOperationModel>;
};
